import React from 'react';
import Router from 'react-router-dom/BrowserRouter';
import Switch from 'react-router-dom/Switch';
import Route from 'react-router-dom/Route';
import createBrowserHistory from 'history/createBrowserHistory';
import Header from './header';
import Sidebar from './sidebar';
import UnlockFeature from './unlock_feature';
import Weather from '../weather';
import MobileDemo from '../MobileDemo';

const history = createBrowserHistory();

export default class Layout extends React.Component {

  render() {
    return (
      <Router basename="webplugin" history={history}>
        <Switch>
          <Route path="/mobiledemo" component={MobileDemo} />
          <Route path="/" render={() => (
              <div className="main-container">
                <Sidebar />
                <UnlockFeature />
                <Header />
                <div className="content">
                  <Weather />
                </div>
              </div>
            )}
          />
        </Switch>
      </Router>
    );
  }

}




// WEBPACK FOOTER //
// ./src/components/common/Layout.js